import Model from "../Model";

class Dimensionfiltertops extends Model{

    buildUrl ({ param }) {
        return ['//filters/getgroupfilter', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Dimensionfiltertops;